export default "__VITE_ASSET__CxjYPauZ__"